import "./DirectionChangeIndicatorV2.scss";
import {IComponentOptions, IOnChanges, IOnChangesObject} from "angular";
import {Optional} from "../../../js/util/Optional";

export const DirectionChangeIndicatorV2 = "tfDirectionChangeIndicatorV2";

export function directionChangeIndicatorV2(): IComponentOptions {
    return {
        templateUrl: "app/components/ui/change-indicator/DirectionChangeIndicator.html",
        bindings: {
            changeAmount: "<",
            invert: "<"
        },
        controllerAs: "ctrl",
        controller: DashboardPortfolioBalanceChangeIndicatorControllerV2
    };
}

const NO_CHANGE = "icon-circle-minus";
const CHANGE_UP = "icon1-arrow1-up";
const CHANGE_DOWN = "icon1-arrow1-down";

const GOOD = "summary-green";
const BAD = "summary-red";

export class DashboardPortfolioBalanceChangeIndicatorControllerV2 implements IOnChanges {

    public changeAmount: number | null;
    public invert: boolean | null;

    public indicatorClass = NO_CHANGE;

    public $onChanges(changes: IOnChangesObject): void {
        const directionClass = this.directionClass();
        const directionColourClass = this.directionColour();
        this.indicatorClass = `${directionClass} ${ directionColourClass}`;
    }

    private directionClass(): string {
        if (this.changeAmount == null || this.changeAmount === 0) {
            return NO_CHANGE;
        } else if (this.changeAmount < 0) {
            return CHANGE_DOWN;
        } else {
            return CHANGE_UP;
        }
    }

    private directionColour(): string {
        const invert = Optional.of(this.invert).orElse(false);

        if (this.changeAmount == null || this.changeAmount === 0) {
            return "";
        } else if (this.changeAmount < 0 && invert) {
            return GOOD;
        } else if (this.changeAmount < 0 && !invert) {
            return BAD;
        } else if (this.changeAmount > 0 && invert) {
            return BAD;
        } else {
            return GOOD;
        }
    }
}
